import HouseFilledIcon from './HouseFilledIcon';
export default HouseFilledIcon;
